const initialState = {
  authorNames: [],
  blogCategories: [],
  search: "",
};

export default initialState;
